import { DraftConfigurationTextStyle, PrintArea, PrintType, Size } from '@/types';
import { round } from '@/utils/math/round';
import { getMinFontSize } from '@/utils/text/getMinFontSize';
import { getPrintAreaSize } from '@/model/printArea/getPrintAreaSize';
import { rotatedSize } from './rotatedSize';

export function getScaleAndFontSize(
  style: DraftConfigurationTextStyle,
  rotation: number,
  size: Size,
  printArea: PrintArea,
  printType: PrintType,
  scale: number
) {
  const rotatedBoundingBox = rotatedSize(rotation, size);

  // -1 to mirror maxScale calculation in currentSizeAndMaxScale which is used in the validation
  const printAreaSize = getPrintAreaSize(printArea);
  const printTypeSize = printType.size;
  const availableWidth = Math.min(printAreaSize.width, printTypeSize.width) - 1;
  const availableHeight = Math.min(printAreaSize.height, printTypeSize.height) - 1;
  const maxScale = Math.min(
    availableWidth / rotatedBoundingBox.width,
    availableHeight / rotatedBoundingBox.height
  );

  let newScale = Math.min(scale, maxScale);
  let newFontSize = style.fontSize * newScale;

  if (newScale === maxScale) {
    // if the text is close to the max size, decrease the size
    //  a small amount to prevent validation issues
    newFontSize = round(newFontSize - 0.2, 1);
    newScale = newFontSize / style.fontSize;
  }

  const minFontSize = getMinFontSize(printType, style.font);
  if (newFontSize < minFontSize) {
    newFontSize = minFontSize;
    newScale = newFontSize / style.fontSize;
  }

  return {
    fontSize: newFontSize,
    scale: newScale,
  };
}
